import { render, staticRenderFns } from "./PersonManagement.vue?vue&type=template&id=05c77514&scoped=true"
import script from "./PersonManagement.vue?vue&type=script&lang=js"
export * from "./PersonManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c77514",
  null
  
)

export default component.exports